import React from "react";
import { STORIA } from "../../data/content";
import Reveal from "./Reveal";

export const Storia = () => (
  <section
    id="storia"
    data-testid="storia-section"
    className="bg-navy text-white py-20 md:py-32 relative overflow-hidden"
  >
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
      <div className="mb-16 md:mb-24">
        <p className="font-sub uppercase tracking-[0.3em] text-gold font-bold text-sm mb-4">
          La Nostra Storia
        </p>
        <h2 className="font-heading uppercase leading-[0.9] text-white text-4xl md:text-6xl tracking-tight max-w-3xl">
          Quasi sessant&apos;anni di canestri
        </h2>
      </div>

      <div className="relative">
        {/* vertical line */}
        <div className="absolute left-0 md:left-[38%] top-0 bottom-0 w-px bg-white/20 hidden md:block" />

        <div className="space-y-16 md:space-y-24">
          {STORIA.map((item, i) => (
            <Reveal key={item.year} y={60}>
              <div
                data-testid={`storia-item-${item.year}`}
                className="grid md:grid-cols-12 gap-6 md:gap-12 items-start"
              >
              <div className="md:col-span-5 md:text-right md:pr-16 relative">
                <span className="font-heading text-7xl md:text-8xl lg:text-9xl text-outline-white leading-none">
                  {item.year}
                </span>
              </div>
              <div className="md:col-span-7 relative md:pl-4">
                <span className="hidden md:block absolute -left-[1.15rem] top-2 w-4 h-4 bg-gold rotate-45" />
                <div className="font-sub uppercase tracking-wide text-gold text-sm font-bold mb-2">
                  Capitolo {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="font-heading uppercase text-2xl md:text-3xl text-white mb-3">
                  {item.title}
                </h3>
                <p className="font-body text-white/70 text-base md:text-lg leading-relaxed max-w-xl">
                  {item.text}
                </p>
              </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Storia;
